<template>
    <router-view
        :antispam_controller="antispam_controller"
    />
</template>


<script setup>
    import {reactive}             from 'vue';
    import AntiSpamController     from '@/js/Settings/AntiSpam/AntiSpamController.js';

    const antispam_controller = reactive(AntiSpamController);
</script>